export const updateMouseXY = (x, y) => ({
  type: "UPDATE_MOUSE_XY",
  x,
  y,
});
